<template>
  <div class="wd-box">
      <div class="dianzan-box">
      <i :class="{active:dianzanState}">+1</i>
      <img src="../assets/img/dianzhan.png" alt="" @click="dianzan" />
    </div>
    <div class="wd-header">
      <div class="bx-content flex-center between-box wd-header-center">
        <img src="../assets/img/flogo.png" alt="">
        <div class="flex-center ">
          <p><span>服务热线：</span>010-88810708</p>
          <a href="http://demo.csz.emof.cn/web/">返回公益汇首页</a>
        </div>
      </div>
    </div>
    <div class="bx-content">
      <div class="nav-box flex-center between-box">
        <div class="flex-center around-box nav-item">
          <a href="javascript:void 0" @click="goAnchor('#pageTop')">
            <img src="../assets/Template/4_03.png" alt="">
          </a>
          <a href="javascript:void 0" @click="goAnchor('#pageInfo')">
            <img src="../assets/Template/4_05.png" alt="">
          </a>
        </div>
        <div class="org-logo-info">
          <div>
            <div class="logo-box" v-if="apply_info.logo_url">
              <img :src="apply_info.logo_url" alt="" >
            </div>

<!--            <img src="../assets/img/logo.png" alt="" >-->
            <p>{{userinfo.name}}</p>
          </div>
        </div>
        <div class="flex-center around-box nav-item">
          <a href="javascript:void 0" @click="goAnchor('#pageFc')">
            <img src="../assets/Template/4_07.png" alt="">
          </a>
          <a href="javascript:void 0" @click="goAnchor('#pageCall')">
            <img src="../assets/Template/4_09.png" alt="">
          </a>
        </div>
      </div>
      <div id="pageInfo" class="org-info">
        <div class="info-text">
          <p style="text-indent: 32px;">{{ userinfo.name }} ，
            {{ userinfo.chengli_time }} 在 {{ userinfo.administration }} 登记成立，
            <span v-if="userinfo.registered_capital">注册资金 {{ userinfo.registered_capital }} 元，</span>
            法定代表人/负责人是 {{ userinfo.legal_person }} 。
            秘书处位于 {{ apply_info.secretariat_address }} ，
            现有专职 {{ apply_info.major_num }} 人，
            党员 {{ apply_info.party_num }} 人
            <span v-if="apply_info.party_name">，成立有 {{ apply_info.party_name }}</span> 。
            <span v-if="userinfo.examine">经 {{ userinfo.examine }} 评定，评估等级为 {{ userinfo.level }} 级，有效期为{{ userinfo.end_time }}。</span>
            <span v-for="(item,index) in userinfo.year.length" :key="item">
            <i v-if="userinfo.conclusion[index]">{{ userinfo.year[index] }}年度年检（年报）结论为 {{ userinfo.conclusion[index] }} ，</i>
          </span>
            业务范围包括{{ userinfo.range }}
            <span v-if="project_info.length>0">高质量完成 {{project_info[0].entry_name}} 等项目；</span>
            <span v-if="honor.length>0">曾获得 {{ honor[0].honor_name }} 等荣誉表彰。</span>
            联系人：{{apply_info.contacts}} ，
            联系电话：{{apply_info.phone}} ，
            邮箱： {{apply_info.email}}。</p>
          <img src="../assets/Template/4_16.jpg" alt="" class="org-desc-bg">
          <div class="org-desc-img">
            <img :src="organization[0].img_url" alt="">
          </div>

        </div>
        <div class="org-desc-btn">
          <img src="../assets/Template/4_19.png" alt="" @click="negotiationVisible=true">
          <img src="../assets/Template/4_21.png" alt="" @click="telVisible = true">
          <img src="../assets/Template/4_23.png" alt="" @click="codeVisible = true">
        </div>
      </div>

      <div class="project-info" v-if="project_info.length>0">
        <img src="../assets/Template/4_55.jpg" alt="" class="lanmu-title">
        <div class="project1" v-if="project_info.length===1">
          <a :href="'http://demo.csz.emof.cn/web/xiangmuZdetail.html?id=' + project_info[0].user_id">
            <img :src=" project_info[0].xiangmu_kaizhan_img[0]" alt="">
            <img src="../assets/img/jiaobiaoTJ.png" alt="" v-if="project_info[0].instructions" style="position: absolute;top: 0;right: 0;width: 71px;height: 71px;">

            <p class="ovHide">{{ project_info[0].entry_name }}</p>
          </a>
        </div>
        <div class="project2" v-if="project_info.length===2">
          <a :href="'http://demo.csz.emof.cn/web/xiangmuZdetail.html?id=' + project_info[0].id">
            <img :src=" project_info[0].xiangmu_kaizhan_img[0]" alt="">
            <img src="../assets/img/jiaobiaoTJ.png" alt="" v-if="project_info[0].instructions" style="position: absolute;top: 0;right: 0;width: 71px;height: 71px;">
            <p>{{ project_info[0].entry_name }}</p>
          </a>
          <a :href="'http://demo.csz.emof.cn/web/xiangmuZdetail.html?id=' + project_info[1].id">
            <img :src=" project_info[1].xiangmu_kaizhan_img[0]" alt="">
            <img src="../assets/img/jiaobiaoTJ.png" alt="" v-if="project_info[1].instructions" style="position: absolute;top: 0;right: 0;width: 71px;height: 71px;">
            <p>{{ project_info[1].entry_name }}</p>
          </a>
        </div>
        <div class="project3" v-if="project_info.length > 2">
          <el-carousel :interval="4000" indicator-position="none" type="card" height="320px;">
            <el-carousel-item v-for="(item,index) in project_info" :key="index">
              <a :href="'http://demo.csz.emof.cn/web/xiangmuZdetail.html?id=' + item.id">
                <img :src="item.xiangmu_kaizhan_img[0]" alt="">
                <img src="../assets/img/jiaobiaoTJ.png" alt="" v-if="item.instructions" style="position: absolute;top: 0;right: 0;width: 71px;height: 71px;">
                <p>{{item.entry_name}}</p>
              </a>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div id="pageFc" class="fc-info fc-info4">
        <img src="../assets/Template/4_30.jpg" alt="" class="lanmu-title">
        <div class="fc-show flex-center between-box">
          <el-carousel
            ref="carousel"
            :autoplay="false"
            arrow="always"
            indicator-position="none"  height="480px;" style="width:722px;height: 480px;">
            <el-carousel-item v-for="(item,index) in organization" :key="index" name="index" :label="item.title">
              <img :src="item.img_url" alt="" class="swiper-img" >
            </el-carousel-item>
          </el-carousel>
          <div class="right-fc" :class="{active:organization.length>6}">
            <div v-for="(item,index) in organization" :key="index" :class="{active:fcNav === index}" :data-index="index" @mouseover="setActiveItem(index)"  @click="showImg(index)">
              <img :src="item.img_url" alt="">
            </div>
          </div>
        </div>
      </div>

      <div id="pageCall" class="call-info">
        <img src="../assets/Template/4_00.jpg" alt="" class="lanmu-title">
        <div class="call-box">
          <div>
            <h2><span>联系人：</span>{{apply_info.contacts}}</h2>
            <h2><span>联系电话：</span>{{apply_info.phone}}</h2>
          </div>
          <div class="active">
            <h3>秘书处地址 </h3>
            <h2>{{ apply_info.secretariat_address }}</h2>
          </div>
        </div>
      </div>

    </div>
    <div class="wd-footer">
      <div class="bx-content flex-center between-box wd-footer-content">
        <img src="../assets/img/flogo.png" alt="">
        <div class="footer-center">
          <p>主办单位：北京市委社会工委市民政局</p>
          <p>执行单位：北京市社会组织管理中心 </p>
          <p>协办单位：北京市扶贫协作和支援合作工作领导小组办公室 中关村科技园区管理委员会 </p>
          <p>北京市妇女联合会 北京市红十字会 首都公益慈善联合会</p>
          <p>承办单位：北京知诚社会组织众扶发展促进会</p>
          <p>All Rights Reserved <a href="http://www.beian.gov.cn" style="color: #fff;">京ICP备17050284号-4</a></p>

        </div>
        <div class="footer-ewm">
          <img src="../assets/img/ggh.png" alt="">
          <p>众扶平台公众号</p>
        </div>
      </div>
    </div>
    <div v-if="showImgIndex !== 0">
    <el-dialog
      :title="titleList[showImgIndex]"
      :visible.sync="centerDialogVisible"
      width="80%"
      center>
      <div style="height:60vh;">
        <img :src="organization[showImgIndex].img_url" alt=""
             style="width: 100%;
        height: 100%;
        vertical-align: top;
        object-fit: scale-down;">
      </div>

      <div style="width: 200px;margin: 20px auto;display: flex;align-items: center;justify-content: space-around;">
        <el-button @click="pre">上一张</el-button>
        <el-button @click="next">下一张</el-button>
      </div>
    </el-dialog>
    </div>
    <el-dialog
      title="文字洽谈"
      :visible.sync="negotiationVisible"
      width="700px"
      center>
      <negotiation @submitOk="submitOk"/>
    </el-dialog>
    <el-dialog
      title="一键转发"
      :visible.sync="codeVisible"
      width="700px"
      center>
      <codes :template="4"/>
    </el-dialog>
    <el-dialog
      title="一键通话"
      :visible.sync="telVisible"
      width="700px"
      center>
      <tel :name="apply_info.contacts" :tel="apply_info.phone" />
    </el-dialog>
  </div>
</template>

<script>
import negotiation from '../components/negotiation'
import codes from '../components/codemode'
import tel from '../components/tel'
export default {
  name: "Template4",
  components:{
    negotiation,
    codes,
    tel
  },
  data() {
    return {
      negotiationVisible:false,
      codeVisible:false,
      telVisible:false,
      userinfo: {
        "phone": '',
        "name": '',
        "chengli_time": '',
        "administration": '',
        "legal_person": '',
        "manage_depart": '',
        "registered_capital": '',
        "range": '',
        "level": '',
        "end_time": '',
        "examine": '',
        "conclusion": "",
        "year": "",
        "regist_no": "",
        "unified_code": '',
        "org_type": '',
        "business_unit": '',
        "registration_status": "正常",
        "address": '',
        "create_time": '',
        "shop_id": '',
      },
      apply_info: {
        "user_id": '',
        "contacts": '',
        "website": '',
        "email": '',
        "shenbao_phone": '',
        "assets": '',
        "expenditure": '',
        "is_dishonesty": '',
        "is_punish": '',
        "is_investigation": '',
        "legal_person_img": '',
        "level_img": '',
        "desc": '',
        "secretariat_address": '',
        "major_num": '',
        "party_num": '',
        "party_name": '',
        "logo_url": '',
      },
      project_info: [],
      organization: [],
      honor: [],
      srcList: [],
      fcNav:0,
      titleList: [],
      centerDialogVisible: false,
      showImgIndex: 0,
       dianzanState:false,
    }
  },
  created() {
     this.$api.apiContent.dianzan2({
        type: '组织展详情',
        t_id: this.$route.query.id,
        op: 1,
      })
    this.browserRedirect()
    if(this.$route.query.id){
      this.getInstitutionInfo()
    }
  },
  methods: {
    browserRedirect() {
      var sUserAgent = navigator.userAgent.toLowerCase();
      var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
      var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
      var bIsMidp = sUserAgent.match(/midp/i) == "midp";
      var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
      var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
      var bIsAndroid = sUserAgent.match(/android/i) == "android";
      var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
      var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
      if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
        document.writeln();
        window.location.href = 'http://demo.csz.emof.cn/m/#/Content/template1?id=' + this.$route.query.id
      } else {
        return
      }
    },
    dianzan(){
       this.$api.apiContent.dianzan2({
        type: '组织展详情',
        t_id: this.$route.query.id,
        op: 2,
      })
       this.dianzanState = true
      setTimeout(() => {
        this.dianzanState = false
      }, 600)
      let _token = ''
      if(window.localStorage.getItem('user')){
        _token = JSON.parse(window.localStorage.getItem('user')).token
      }
      this.$api.apiContent.dianzan({
        other_user_id: this.$route.query.id,
        token:_token
      }).then(() => {
        // this.$message.success('点赞成功')
      }).catch(()=>{
        // this.$message.success('点赞成功')
      })
    },
    submitOk(){
      this.negotiationVisible = false
    },
    pre() {
      this.showImgIndex--
      if (this.showImgIndex < 0) {
        this.showImgIndex = this.organization.length - 1
      }
    },
    next() {
      this.showImgIndex++
      if (this.showImgIndex >= this.organization.length) {
        this.showImgIndex = 0
      }
    },
    showImg(num) {
      this.centerDialogVisible = !this.centerDialogVisible
      this.showImgIndex = num
    },
    setActiveItem(index){
      this.fcNav = index
      this.$refs.carousel.setActiveItem(index)
    },
    getInstitutionInfo() {
      this.$api.apiContent.get_institution_info({
        institution_id: this.$route.query.id
      }).then(res => {
        this.userinfo = res.data.userinfo
        this.apply_info = res.data.apply_info
        this.project_info = res.data.project_info
        this.organization = res.data.organization
        this.honor = res.data.honor
        if (this.organization.length > 0) {
          this.organization.map(item => {
            this.srcList.push(item.img_url)
            this.titleList.push(item.title)
          })
        }
        this.project_info.map(item => {
          item.xiangmu_kaizhan_img = item.xiangmu_kaizhan_img.split(',')
        })

        this.userinfo.conclusion = this.userinfo.conclusion?this.userinfo.conclusion.split(';'):[]
        this.userinfo.year = this.userinfo.year?this.userinfo.year.split(';'):[]

      })
    },
    goAnchor(selector) {
      var anchor = document.querySelector(selector)
      //   没有动画
      //   document.documentElement.scrollTop = anchor.offsetTop
      //   有动画
      this.scrollTo(anchor.offsetTop, 500)
    },
    scrollTo(y, duration) {
      /* y:目标纵坐标,duration:时间(毫秒) */

      var scrollTop = document.body.scrollTop /* 页面当前滚动距离 */

      var distance =
        y -
        scrollTop /* 结果大于0,说明目标在下方,小于0,说明目标在上方 */

      var scrollCount = duration / 10 /* 10毫秒滚动一次,计算滚动次数 */

      var everyDistance = parseInt(
        distance / scrollCount
      ) /* 滚动距离除以滚动次数计算每次滚动距离 */

      for (
        var index = 1;
        index <= scrollCount;
        index++ /* 循环设置scrollBy事件,在duration之内,完成滚动效果 */
      ) {
        setTimeout(function () {
          window.scrollBy(0, everyDistance)
        }, 10 * index)
      }
      let deviation = y - scrollCount * everyDistance
      window.scrollBy(0, deviation)
    }

  }
}
</script>

<style scoped lang="scss">
.wd-box {
  background: #fff;
  .dianzan-box {
    z-index: 99;
    position: fixed;
    right: 0;
     top: 70%;
    cursor: pointer;
    i {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%, 0);
      font-size: 16px;
      color: red;
      opacity: 0;
      transition: all .6s linear;
      &.active {
        top: -50px;
        opacity: 1;
        font-size: 36px;
      }
    }
  }
  .wd-header {
    height: 132px;
    background: url(../assets/Template/4_01.jpg) no-repeat top center;

    .wd-header-center {
      height: 130px;

      div {
        p {
          font-size: 30px;
          color: #ffecc3;

          span {
            font-size: 18px;
            color: #ffecc3;
          }
        }

        a {
          display: block;
          margin-left: 25px;
          width: 178px;
          height: 42px;
          text-align: center;
          line-height: 42px;
          font-size: 18px;
          color: #c70005;
          background-color: #fff100;
          border-radius: 21px;
        }
      }
    }
  }
  .nav-box{
    width: 1200px;
    height: 114px;
    background-color: #f3f3f3;
    margin-bottom: 80px;
    border-radius: 10px;
    .nav-item{
      width: 350px;
    }
    .org-logo-info{
      height: 142px;
      width: 547px;
      background: url(../assets/Template/4-10.png) no-repeat top center;
      display: flex;
      align-items: center;
      justify-content: space-around;
      div{
        display: flex;
        align-items: center;
        padding: 0 80px;
        height: 142px;
        .logo-box{
          display: flex;
          align-items: center;
          justify-content: space-around;
          width: 100px;
          height: 100px;
          border-radius: 100px;
          border:1px solid  #fff100;
          margin-right: 20px;
          padding: 0;
          overflow: hidden;
          img{
            display: block;
            width: 100px;
          }
        }

        p{
          flex: 1;
          font-size: 26px;
          line-height: 36px;
          font-weight: bold;
          color: #fff;
          text-align: center;


        }
      }
    }
  }
  .org-info{
    .info-text{
      width: 1200px;
      min-height: 374px;
      padding: 37px 29px;
      margin-bottom: 10px;
      border-radius: 8px;
      border: solid 1px #cccccc;
      position: relative;
      p{
        width: 591px;
        font-size: 16px;
        line-height: 28px;
      }
      .org-desc-bg{
        position: absolute;
        top: 45px;
        right: 0;
        width: 515px;
        height: 426px;
      }
      .org-desc-img{
        position: absolute;
        top: 0px;
        right: 45px;
        width: 515px;
        height: 426px;
        img{
          width: 100% ;
          height: 100% ;
          vertical-align: top;
          object-fit: scale-down;
        }
      }
    }
    .org-desc-btn{
      display: flex;
      align-items: center;
      margin-bottom: 40px;
      img{
        display: block;
        margin-right: 10px;
        cursor: pointer;
      }

    }
  }
  .project-info{
    margin-bottom: 40px;
    .project1 {
      width: 1200px;
      margin: 30px auto;

      a {
        display: block;
        width: 500px;
        height: 320px;
        margin: 0 auto;
        position: relative;

        img {
          width: 100%;
          height: 100%;
          vertical-align: top;
          object-fit: scale-down;
        }

        p {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 52px;
          text-align: center;
          line-height: 52px;
          color: #fff;
          font-size: 16px;
          background-color: #ff7200;
        }
      }
    }

    .project2 {
      width: 1200px;
      margin: 30px auto;
      display: flex;
      align-items: center;
      justify-content: space-between;

      a {
        display: block;
        width: 500px;
        height: 320px;
        margin: 0 auto;
        position: relative;

        img {
          width: 100%;
          height: 100%;
          vertical-align: top;
          object-fit: scale-down;
        }

        p {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 52px;
          text-align: center;
          line-height: 52px;
          color: #fff;
          font-size: 16px;
          background-color: #ff7200;
        }
      }
    }

    .project3 {
      width: 1200px;
      margin: 30px auto;

      a {
        display: block;
        width: 500px;
        height: 320px;
        margin: 0 auto;
        position: relative;

        img {
          width: 100%;
          height: 100%;
          vertical-align: top;
          object-fit: scale-down;
          background: #fff;
        }

        p {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 72px;
          text-align: center;
          line-height: 52px;
          color: #fff;
          font-size: 16px;
          background-color: #ff7200;
        }
      }
    }
  }
  .fc-info{
    margin-bottom: 40px;
    .swiper-img{
      width: 100%;
      height: 100%;
      vertical-align: top;
      object-fit: scale-down;
    }
    .right-fc{
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      width: 480px;
      height: 480px;
      margin-left: 20px;
      &.active{
        overflow-y: scroll;
      }
      div{
        width: 225px;
        height: 150px;
        margin-bottom: 10px;
        border: 2px solid #ddd;
        &:hover{
          border: 2px solid #ff7200;
        }
        &.active{
          border: 2px solid #ff7200;
        }
        img{
          width: 100%;
          height: 100%;
          vertical-align: top;
          object-fit: scale-down;
        }
      }
    }
  }
  .call-info{
    margin-bottom: 40px;
    .call-box{
      display: flex;
      align-items: center;
      justify-content: space-between;
      div{
        width: 558px;
        height: 180px;
        padding: 60px 40px 40px 215px;
        background: url(../assets/Template/4_24.png) no-repeat top center;
        box-shadow: 0px 0px 10px 0px
        rgba(0, 0, 0, 0.32);
        border-radius: 4px;

        &.active{
          background: url(../assets/Template/4_25.png) no-repeat top center;
        }
        p{
          line-height: 24px;
        }
        h3{
          font-size: 18px;
          line-height: 36px;

        }
        h2{
          line-height: 30px;
          color: #ff7200;
          span{
            font-size: 14px;
            font-weight: normal;
            color: #333;
          }
        }
      }
    }
  }
  .wd-footer {
    background: #333;
    padding: 30px 0;

    .wd-footer-content {
      .footer-logo {
        display: block;
      }

      .footer-center {
        p {
          text-align: center;
          line-height: 36px;
          color: #fff;

          a {
            color: #fff;
          }
        }
      }

      .footer-ewm {
        img {
          display: block;
          width: 100px;
          height: 100px;
        }

        p {
          text-align: center;
          color: #fff;
          line-height: 40px;
        }
      }
    }
  }
}
.lanmu-title{
  margin-bottom: 20px;
}
</style>
